import * as moment from 'moment';
import { Constants } from './constants';

export class CommonFunctions {
  public static trunc(num, dec) {
    num = +num;
    if (num % 1 === 0) {
      return num.toFixed(dec);
    } else {
      const exp = Math.pow(10, dec || 2);
      const result = parseInt(String(num * exp), 10) / exp;
      const resultS = result.toString();

      if (+resultS.split('.')[1] > 0  && +resultS.split('.')[1] <= 9) {
        return result.toFixed(2);
      } else {

        if (result % 1 === 0) {
          return result.toFixed(2);
        } else {
          return result;
        }
      }
    }
  }

  public static getAvailableFactorToConsolidate(date) {
    const dateEntered = moment(date, 'DD/MM/YYYY').locale('es');
    const currentDate = moment().locale('es');
    const days = currentDate.diff(dateEntered, 'days');
    let months = days / Constants.EXTERNAL_DEBTS_DATE_FACTOR;
    months = Math.trunc(months);
    return months;
  }

  public static async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  public static validateEmail(email) {
    const emailRegex = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|\[[\t -Z^-~]*])$/i;
    if (emailRegex.test(email)) {
      return true;
    } else {
      return false;
    }
  }

  public static cleanSpacesString(text) {
    return text.replace(' ', '.');
  }

  public static getNitWithUnderscore(nit: any) {
    const evaluateNit = this.cleanNit(nit);
    return evaluateNit.toString().slice(0, ( evaluateNit.length - 1 ))
      + '-' + evaluateNit.toString().slice((evaluateNit.length - 1 ));
  }

  public static cleanNit(nit: any) {
    let evaluateNit = nit.trim();
    if (evaluateNit && evaluateNit !== '') {
      const underscorePosition = evaluateNit.search('-');
      if (underscorePosition > 0) {
        evaluateNit = Number(evaluateNit.substr(0, underscorePosition)).toString()
          + evaluateNit.substr(underscorePosition + 1, evaluateNit.length - 1);
      }
      const regExp = new RegExp('[a-zA-Z]');
      if (regExp.test(evaluateNit)) {
        const letterPosition = evaluateNit.search(regExp);
        const letter = evaluateNit.substr(letterPosition).toUpperCase();
        evaluateNit = Number(evaluateNit.substr(0, letterPosition)).toString() + letter;
      }

      if (!regExp.test(evaluateNit)) {
        evaluateNit = Number(evaluateNit).toString();
      }
      return evaluateNit;
    }
  }

  public static validateIndirectCreditsCoDebtor(
    internalProductsDebtor,
    internalProductsCoDebtor,
    clientProducts,
  ) {
    let canCoDebtor = true;
    let isCommonCreditConsolidated = true;
    const commonCredits = [];
    const debtorCredits = internalProductsDebtor.creditos;
    const coDebtorCredits = internalProductsCoDebtor.creditos;
    if (coDebtorCredits) {
      coDebtorCredits.forEach(credit => {
        if (credit.directoIndirecto
          && credit.directoIndirecto === 'INDIRECTO'
          && debtorCredits) {
           const findCommonCredit = debtorCredits.find(
             item => item.noCredito === credit.noCredito
              && item.directoIndirecto === 'DIRECTO',
           );
           if (findCommonCredit) {
             commonCredits.push(findCommonCredit);
           }
        }
      });

      if (commonCredits.length === 0) {
        coDebtorCredits.forEach(credit => {
          if (credit.directoIndirecto === 'INDIRECTO'
            && canCoDebtor === true) {
            canCoDebtor = false;
          }
        });
      } else {
        commonCredits.forEach(credit => {
          if (clientProducts && clientProducts.length > 0) {
            credit.consolidado = true;
            const findCredit = clientProducts.find(item => item.noCredito === credit.noCredito);
            if (findCredit) {
              if (findCredit.permitidoConsolidar && !findCredit.consolida) {
                credit.consolidado = false;
                isCommonCreditConsolidated = false;
              }
            }
          }
        });
      }
    }
    return {
      canCoDebtor,
      commonCredits,
      isCommonCreditConsolidated,
    };
  }
  public static getDateFormatHyphenToSlash(date) {
    const fecha = moment(date, 'YYYY-MM-DD').locale('es').format('DD/MM/YYYY');
    return fecha.toString();
  }
}
